import $ from "jquery";
window.$ = window.jQuery = $;

import './bootstrap';
import './Main';
